import { createRoute, redirect } from '@tanstack/react-router'
import { useState } from 'react'
import { rootRoute } from './__root'
import { WorkspaceHeader } from '@/components/WorkspaceHeader'
import { MidiRouter } from '@/components/midi/MidiRouter'
import { MidiMonitor } from '@/components/midi/MidiMonitor'
import { PerformanceKeyboard } from '@/components/midi/PerformanceKeyboard'
import { UpgradeDialog } from '@/components/panels/UpgradeDialog'
import { apiClient } from '@/lib/api'
import { usePlatform } from '@/hooks/usePlatform'

export const werkshopMidiRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/werkshop/midi',
  beforeLoad: async () => {
    try {
      await apiClient.get('/api/v1/auth/me')
    } catch {
      // Same gating as /home — anything other than success bounces to
      // /login. The router has no useful state without auth either,
      // since routes are persisted per browser/profile.
      throw redirect({ to: '/login' })
    }
  },
  component: MidiPage,
})

function MidiPage() {
  const [upgradeOpen, setUpgradeOpen] = useState(false)
  const platform = usePlatform()

  return (
    <div className="min-h-[100dvh] bg-surface-base">
      <WorkspaceHeader title="MIDI Router" workspaceSwitcher="werkshop" />
      <main
        className={
          platform.isNative
            ? 'w-full px-3 sm:px-4 py-4 flex flex-col gap-4'
            : 'max-w-5xl mx-auto px-4 sm:px-6 py-6 sm:py-8 flex flex-col gap-6'
        }
      >
        <MidiRouter
          variant="page"
          onRouteLimitReached={() => setUpgradeOpen(true)}
        />
        <PerformanceKeyboard />
        <MidiMonitor variant="page" />
      </main>
      <UpgradeDialog
        isOpen={upgradeOpen}
        onClose={() => setUpgradeOpen(false)}
      />
    </div>
  )
}
